import {gql} from "apollo-angular";
import {baseResponse} from "../../base.graphql";

export const mediaFields = `
    id
      imageUniqueId
      imagePath
      imageName
      imageType
      imageRedirectLink
`;

export const UPLOAD_LANDING_BASE64_FILE = gql`
    mutation UploadLandingBase64File($input: UploadBase64LandingImagesInputObjects!) {
        uploadLandingBase64File(input: $input) {
            response {
                ${baseResponse}
            }
            data {
                ${mediaFields}
            }
        }
    }
`;

export const GET_MEDIA_IMAGES = gql`
    query GetMediaImages($filtering: FileFilteringObjects) {
        getMediaImages(filtering: $filtering) {
            response {
                ${baseResponse}
            }
            data {
                ${mediaFields}
            }
        }
    }
`


export const DELETE_MEDIA_IMAGE = gql`
    mutation DeleteLandingBase64File($imageUniqueId: String!) {
        deleteLandingBase64File(imageUniqueId: $imageUniqueId) {
            response {
                ${baseResponse}
            }
        }
    }
`;

export const CITIZEN_GET_MEDIA_IMAGES = gql`
    query CitizenGetMediaImages($filtering: FileFilteringObjects) {
        citizenGetMediaImages(filtering: $filtering) {
            response {
                ${baseResponse}
            }
            data {
                ${mediaFields}
            }
        }
    }
`;
